jQuery(document).ready(function () {
  var $slider = jQuery('.product-image-slider');

  if ($slider.length === 0) {
    return;
  }

  $slider.each(function() {
    $(this).slick({
      arrows: true,
      dots: false,
      infinite: false,
      prevArrow: $(this).siblings('.product-image-slider-controls').children('.prev'),
      nextArrow: $(this).siblings('.product-image-slider-controls').children('.next'),
    });
  
    var $slides = $(this).find('.product-image-slide');
  
    if ($slides.length === 1) {
      $(this).siblings('.product-image-slider-controls').remove();
    }
  });
});
